var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebsiteDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 46,
    viewBox: "0 0 51 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.33 35.683c-1.882 0-3.408-1.562-3.408-3.488V15.348h34.28v16.847c0 1.926-1.526 3.488-3.409 3.488H6.33zM6.281 2.99h27.512c1.883 0 3.409 1.562 3.409 3.488v5.88H2.922v-5.88c0-1.926 1.526-3.488 3.408-3.488h-.049zM6.331 0C2.833 0 0 2.692 0 6.012v26.546c0 3.32 2.834 6.012 6.33 6.012h27.463c3.496 0 6.33-2.692 6.33-6.012V6.012c0-3.32-2.834-6.012-6.33-6.012H6.33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.217 5.774a1.443 1.443 0 1 1 0 2.886 1.443 1.443 0 0 1 0-2.886M14.434 7.217a1.443 1.443 0 1 1-2.887 0 1.443 1.443 0 0 1 2.887 0zM20.31 8.66h12.785c.854 0 1.547-.646 1.547-1.443s-.693-1.443-1.547-1.443H20.311c-.854 0-1.547.646-1.547 1.443s.693 1.443 1.547 1.443"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26 21)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#D0021B"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.438 16.438L8.563 8.561M8.562 16.438l7.876-7.875"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteDelete);
export default __webpack_public_path__ + "static/media/website-delete.2ceaabcdbba48d5e4bceb894f3c888f5.svg";
export { ForwardRef as ReactComponent };